import {
  PaymentState,
  GET_ALL_PAYMENT,
  GET_ALL_PAYMENT_SUCCESS,
  GET_ALL_PAYMENT_FAILURE,
  RESET_PAYMENT,
  PaymentActionTypes,
  GET_PAYMENT_METHODS,
  GET_PAYMENT_METHODS_SUCCESS,
  GET_PAYMENT_METHODS_FAILURE,
} from "../types/paymentTypes";

const initialState: PaymentState = {
  paymentMethods: [],
  paymentList: null,
  paymentSuccess: null,
  paymentError: null,
  paymentLoading: false,
};

export const paymentReducer = (
  state = initialState,
  action: PaymentActionTypes
): PaymentState => {
  switch (action.type) {
    case GET_ALL_PAYMENT: {
      return {
        ...state,
        paymentList: [],
        paymentError: null,
        paymentLoading: true,
      };
    }

    case GET_ALL_PAYMENT_SUCCESS: {
      return {
        ...state,
        paymentList: action.payload,
        paymentError: null,
        paymentLoading: false,
      };
    }

    case GET_ALL_PAYMENT_FAILURE: {
      return { ...state, paymentError: action.payload, paymentLoading: false };
    }

    case GET_PAYMENT_METHODS:
      return {
        ...state,
        paymentLoading: true,
        paymentError: null,
        paymentMethods: [],
      };

    case GET_PAYMENT_METHODS_SUCCESS: {
      return {
        ...state,
        paymentLoading: false,
        paymentMethods: action.payload.data || [],
        paymentError: null,
      };
    }

    case GET_PAYMENT_METHODS_FAILURE:
      return { ...state, paymentLoading: false, paymentError: action.payload };

    case RESET_PAYMENT: {
      return {
        ...state,
        paymentSuccess: null,
        paymentError: null,
        paymentLoading: false,
      };
    }

    default:
      return state;
  }
};
